import { cn } from "lib/utils";
import React from "react";

import { ActionButton } from "../ActionButton";
import { Stepper } from "../Stepper";
import { TotemHeader } from "../TotemHeader";

type IdentifyScreenProps = {
	onBack: () => void;
	onPlate: () => void;
	onCpf: () => void;
};

export const IdentifyScreen: React.FC<IdentifyScreenProps> = ({
	onBack,
	onPlate,
	onCpf,
}) => (
	<main
		className={cn(
			"mx-auto flex min-h-full w-full max-w-[800px] flex-col items-center gap-14 bg-white px-6 pb-14 pt-8 max-[1023px]:px-5 max-[1023px]:pb-10 max-[1023px]:pt-6 max-[639px]:gap-8 max-[639px]:px-3 max-[639px]:pb-8 max-[639px]:pt-4",
		)}
	>
		<section
			className={cn(
				"relative h-[415px] w-full shrink-0 max-[639px]:h-[340px]",
			)}
		>
			<div
				className={cn(
					"absolute inset-x-0 top-14 flex h-[359px] flex-col items-start gap-[10px] bg-[#F3F4F6] px-14 pt-24 max-[1023px]:top-12 max-[1023px]:px-8 max-[1023px]:pt-20 max-[639px]:top-10 max-[639px]:h-[300px] max-[639px]:px-4 max-[639px]:pt-20",
				)}
			>
				<Stepper />
				<h1
					className={cn(
						"w-full font-sans text-[32px] font-bold leading-normal text-[#1D293D] max-[639px]:text-[24px]",
					)}
				>
					Vamos identificar você
				</h1>
				<p
					className={cn(
						"w-full font-sans text-[24px] leading-normal text-[#45556C] max-[639px]:text-[17px]",
					)}
				>
					Escolha como deseja localizar seu agendamento
				</p>
			</div>
			<TotemHeader />
		</section>
		<section className={cn("flex w-full flex-col items-start gap-8")}>
			<ActionButton onClick={onPlate}>Placa do veículo</ActionButton>
			<ActionButton onClick={onCpf}>CPF do motorista</ActionButton>
		</section>
		<ActionButton variant="secondary" direction="back" onClick={onBack}>
			Voltar ao início
		</ActionButton>
	</main>
);
